// Simple placeholder for table row actions dropdown
// TODO: Replace with actual UntitledUI table component when available

import { DotsVertical } from "@untitledui/icons"

export const TableRowActionsDropdown = () => {
  return (
    <button
      className="text-fg-quaternary hover:bg-primary_hover rounded-lg p-2"
      aria-label="More actions"
    >
      <DotsVertical className="size-5" />
    </button>
  )
}
